import React from 'react';
import { Box } from '@mui/material';
import PublicNavbar from '../../components/public/PublicNavbar';
import HowItWorks from '../../components/public/HowItWorks';
import { PublicFooter } from '../../components/public/landingSections';

const HowItWorksPage: React.FC = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
    <PublicNavbar />
    <Box
      id="main"
      component="main"
      tabIndex={-1}
      sx={{ px: { xs: 2, sm: 3 }, py: { xs: 4, md: 6 }, maxWidth: 1100, mx: 'auto' }}
    >
      <HowItWorks />
      <PublicFooter />
    </Box>
  </Box>
);

export default HowItWorksPage;
